export default "__VITE_ASSET__$oRF6j8Z__"